import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ACCESS_FIELDS, ACCESS_LABELS } from "../utils/adminAccess";

// Checkbox list of an admin's access fields. readOnly for owners, whose
// access list is fixed and can't be edited by anyone.
const AccessListEditor = ({ access = {}, onChange, readOnly = false }) => {
  const toggle = (field) => onChange?.({ ...access, [field]: !access[field] });

  return (
    <Row className="my-2">
      {ACCESS_FIELDS.map((field) => (
        <Col sm={6} md={4} key={field}>
          <Form.Check
            type="checkbox"
            id={`access-${field}`}
            label={ACCESS_LABELS[field]}
            checked={access[field] === true}
            disabled={readOnly}
            onChange={() => toggle(field)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default AccessListEditor;
